"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStringEscapeReplacer = void 0;
exports.createStringEscapeReplacer = () => {
    return new StringEscapeReplacerImpl();
};
class StringEscapeReplacerImpl {
    replace(stringToTransform) {
        let result = convertUnicodeSequences(stringToTransform);
        for (let i = 0; i < result.length; i++) {
            replacements.forEach((v, k) => {
                if (result.startsWith(k, i)) {
                    result = result.substring(0, i) + v + result.substring(i + k.length);
                }
            });
        }
        return result;
    }
}
const replacements = new Map([
    ['\\t', '\t'],
    ['\\n', '\n'],
    ['\\b', '\b'],
    ['\\f', '\f'],
    ['\\r', '\r'],
    ['~t', '\t'],
    ['~n', '\n'],
    ['~b', '\b'],
    ['~f', '\f'],
    ['~r', '\r'],
    ['~\\', '\\'],
    ['\\\\', '\\'],
    ['~~', '~'],
    ['\\~', '~'],
    ['~(', '('],
    ['\\(', '('],
    ['~)', ')'],
    ['\\)', ')'],
    ['~[', '['],
    ['\\[', '['],
    ['~]', ']'],
    ['\\]', ']'],
    ['~;', ';'],
    ['\\;', ';'],
    ['~`', '`'],
    ['\\`', '`'],
    ['~"', '"'],
    ['\\"', '"'],
    ['~=', '='],
    ['\\=', '='],
]);
const BACKSLASH = '\\';
const HEX = 16;
const UNICODE_SEQ_LEN = 6;
const convertUnicodeSequences = (str) => {
    let m;
    let start = 0;
    let result = '';
    const reg = /[~\\]u[0-9a-fA-F]{4}/g;
    do {
        m = reg.exec(str);
        if (m) {
            if (m.index > 0 && (str.charAt(m.index - 1) === '\\' || str.charAt(m.index - 1) === '~')) {
                if (start < m.index - 1) {
                    result += str.substring(start, m.index - 1);
                }
                result += str.substring(m.index, m.index + UNICODE_SEQ_LEN);
                start = m.index + UNICODE_SEQ_LEN;
            }
            else {
                if (start < m.index) {
                    result += str.substring(start, m.index);
                }
                const c = Number.parseInt(m[0].substr(2), HEX);
                result += String.fromCharCode(c);
                start = m.index + UNICODE_SEQ_LEN;
            }
        }
        else {
            result += str.substring(start);
        }
    } while (m);
    return result;
};
//# sourceMappingURL=Utils.js.map